<template>
  <!-- v-if="evaluateList.length" -->
  <div
    :class="_.block"
    :style="{
      '--background': `url(${data[0].icon})`,
    }"
  >
    <div :class="_.bg" @click="jump">
      <van-notice-bar :text="text" :speed="30" />
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({
    data() {
      return {
        evaluateList: [],
        text: '',
      }
    },
    mounted() {
      if (this.theme.commodityId) {
        this.getVirtualExchangeEvaluateList()
      }
    },
    methods: {
      jump() {
        this.$router.push({
          name: 'CommentList',
          query: { id: this.theme.commodityId },
        })
      },
      async getVirtualExchangeEvaluateList() {
        this.evaluateList = await this.$dmbcApi.getVirtualExchangeEvaluateList({
          id: this.theme.commodityId,
        })
        let str = ''
        this.evaluateList.forEach(element => {
          str += `${element.userNickName}  ${element.evaluateContent};  `
        })
        this.text = str
      },
    },
  })
</script>

<style lang="scss" module="_">
  // 之前单个img的写法可能受父级 flex: 1 影响图片在ios16以下版本会出问题
  .block {
    font-size: 0;

    .bg {
      background: var(--background) no-repeat;
      background-size: 100% 100%;
      padding: 0 30px 0 30px;
      :global {
        .van-notice-bar {
          background-color: transparent;
          height: 36px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 12px;
          color: #ffffff;
          line-height: 17px;
          text-align: center;
          font-style: normal;
        }
      }
    }
  }
</style>
